import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";
import { apiError } from "@/admin/api";
import { BirdMark } from "@/components/brand";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-dark px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-softlg md:p-10">
        <div className="mb-6 flex items-center gap-3">
          <BirdMark className="h-10 w-10" alt="Sankofa" />
          <div>
            <div className="font-sans text-lg font-700 tracking-[0.16em] text-navy">SANKOFA</div>
            <div className="text-[0.6rem] uppercase tracking-[0.3em] text-slate">Studio Console</div>
          </div>
        </div>
        <h1 className="font-serif text-2xl font-600 text-navy">Sign in</h1>
        <p className="mt-1 text-sm text-mutedink">Internal project management. Authorised staff only.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="mb-1 block text-xs font-600 text-navy">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@sankofa..." data-testid="login-email" required />
          </div>
          <div>
            <label className="mb-1 block text-xs font-600 text-navy">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" required />
          </div>
          <button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full rounded-full bg-gold py-3 font-600 text-navy-dark transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
